<wbo-search-page (prepareInitialFilter)="prepareInitialFilter()">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="identifier">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="category">
                <wbo-category-exclude-sub-search-control></wbo-category-exclude-sub-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'inventoryId'">
                <wbo-inventory-multi-select-search-control></wbo-inventory-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'customObjectId'">
                <wbo-custom-object-multi-select-search-control [productLineContext]="true"></wbo-custom-object-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'includesProductId'">
                <wbo-product-line-multi-select-search-control></wbo-product-line-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'includesExtraId'">
                <wbo-extra-multi-select-search-control></wbo-extra-multi-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'usage'">
                <wbo-single-select-search-control initialDefaultValue="extra" [notifyInitialDefault]="true"
                                                  [allowClearSelectionOption]="false">
                    <wbo-select-options>
                        <wbo-select-option value="extra" label="wbo.product-line.search.option.usage.extra"></wbo-select-option>
                        <wbo-select-option value="composite" label="wbo.product-line.search.option.usage.composite"></wbo-select-option>
                        <wbo-select-option value="plg" label="wbo.product-line.search.option.usage.plg"></wbo-select-option>
                        <wbo-select-option value="none" label="wbo.product-line.search.option.usage.none"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-currency-column field="price"></wbo-currency-column>
        <wbo-column field="plu"></wbo-column>
        <wbo-column field="categoryName"></wbo-column>
        <wbo-numeric-column field="extraUsage" [emptyIfZero]="true" [hideable]="true"></wbo-numeric-column>
        <wbo-numeric-column field="compositeUsage" [emptyIfZero]="true" [hideable]="true" [enabled]="false"></wbo-numeric-column>
        <wbo-numeric-column field="plgUsage" [emptyIfZero]="true" [hideable]="true" [enabled]="false"></wbo-numeric-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action></wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
